import React from 'react';
import { billingCycleLabels } from './constants';

export function DuesSettings({ duesConfig, onEditConfig }) {
  return (
    <div className="space-y-6">
      <div className="bg-white rounded-xl border border-gray-200 p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-bold text-gray-800">Dues Configuration</h3>
          <button onClick={onEditConfig} className="px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700">
            {duesConfig ? 'Edit Configuration' : 'Set Up Dues'}
          </button>
        </div>
        
        {duesConfig ? (
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h4 className="font-medium text-gray-700 mb-2">Billing Details</h4>
              <p className="text-gray-600">Cycle: <span className="font-semibold">{billingCycleLabels[duesConfig.billing_cycle]}</span></p>
              <p className="text-gray-600">Due Day: <span className="font-semibold">{duesConfig.due_day}</span></p>
            </div>
            <div>
              <h4 className="font-medium text-gray-700 mb-2">Category Rates</h4>
              {duesConfig.category_amounts?.map(ca => (
                <p key={ca.category} className="text-gray-600">
                  {ca.category.charAt(0).toUpperCase() + ca.category.slice(1)}: <span className="font-semibold text-emerald-600">${ca.amount.toFixed(2)}</span>
                </p>
              ))}
            </div>
          </div>
        ) : (
          <p className="text-gray-500">No configuration set up yet.</p>
        )}
      </div>
    </div>
  );
}
